import React from "react";
import { Container, Row, Col, Table } from "react-bootstrap";
import { s3_url } from "common/constants";
import LumenNavbar from "../../layout/LumenNavbar";
import NewFooter from "../../layout/NewFooter";
import LumenButton from "../../ui/LumenButton";
import "./NewPricePage.css";

const NewPricePage: React.FC = () => {
  return (
    <>
      <LumenNavbar />
      <div className="new-price-page">
        <section className="npp-cover">
          <div
            className="npp-cover-img"
            style={{ backgroundImage: `url(${s3_url}/cjenik/1.webp)` }}
            aria-hidden="true"
          />
          <div className="npp-cover-overlay" aria-hidden="true" />
          <Container className="position-relative">
            <img
              src={`${s3_url}/cjenik/lumenko-money.webp`}
              alt="Lumenko"
              className="npp-mascot"
              loading="lazy"
            />
          </Container>
        </section>

        <Container>
          <Row className="justify-content-center">
            <Col lg={8} className="text-center">
              <h1 className="npp-title">CJENIK</h1>
            </Col>
          </Row>

          <section className="npp-card mt-2 mb-5">
            <h1 className="npp-card-title text-center">Cjenik poduka</h1>

            <div className="npp-table-wrap">
              <Table borderless responsive className="npp-table">
                <thead>
                  <tr>
                    <th>TRAJANJE</th>
                    <th>CIJENA</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>60 minuta</td>
                    <td>25 €</td>
                  </tr>
                  <tr>
                    <td>90 minuta</td>
                    <td>37 €</td>
                  </tr>
                  <tr>
                    <td>120 minuta</td>
                    <td>48 €</td>
                  </tr>
                </tbody>
              </Table>
            </div>

            <div className="text-center">
              <LumenButton
                to="/poduke/rezervacija"
                className="npp-btn"
                size="lg"
              >
                PRIJAVI SE
              </LumenButton>
            </div>
          </section>

          <Row className="justify-content-center npp-books-block">
            <Col xs="auto">
              <img
                src={`${s3_url}/cjenik/knjige.webp`}
                alt="Knjige"
                className="npp-books"
                loading="lazy"
              />
            </Col>
          </Row>

          <section className="npp-card mt-2 mb-2">
            <h1 className="npp-card-title text-center">
              Cjenik priprema za državnu maturu
            </h1>

            <div className="npp-table-wrap">
              <Table borderless responsive className="npp-table">
                <thead>
                  <tr>
                    <th>PREDMET</th>
                    <th>SATI</th>
                    <th>CIJENA</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>Esej na državnoj maturi</td>
                    <td>12</td>
                    <td>130 €</td>
                  </tr>
                </tbody>
              </Table>
            </div>

            <div className="text-center">
              <LumenButton
                to="/prijava-pripreme-drzavna-matura"
                className="npp-btn"
                size="lg"
              >
                PRIJAVI SE
              </LumenButton>
            </div>
          </section>

          <Row className="justify-content-center">
            <Col lg={8}>
              <p className="npp-note text-center">
                U cijenu je uračunat iznos PDV-a. Mogućnost plaćanja na rate.
              </p>
            </Col>
          </Row>
        </Container>
      </div>
      <NewFooter />
    </>
  );
};

export default NewPricePage;
